<template>
  <AuthLayout :max-width="480">
    <div class="text-center">
      <template v-if="loading">
        <v-progress-circular indeterminate color="primary" class="mb-4" />
        <div>Megerősítés folyamatban...</div>
      </template>

      <template v-else-if="success">
        <v-icon color="success" size="56" class="mb-4">mdi-check-circle</v-icon>
        <v-card-title class="justify-center mb-2"
          >Email cím megerősítve</v-card-title
        >
        <v-card-text
          >Mostantól bejelentkezhet a megadott email címmel.</v-card-text
        >
        <v-btn color="primary" href="/login" class="mt-2">Bejelentkezés</v-btn>
      </template>

      <template v-else>
        <v-icon color="error" size="56" class="mb-4">mdi-alert-circle</v-icon>
        <v-card-title class="justify-center mb-2"
          >Érvénytelen link</v-card-title
        >
        <v-card-text>A megerősítő link érvénytelen vagy lejárt.</v-card-text>
      </template>
    </div>
  </AuthLayout>
</template>

<script setup lang="ts">
import AuthLayout from "@/components/layout/AuthLayout.vue";
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { InvitationService } from "@/services/InvitationService";

const route = useRoute();
const invitationService = new InvitationService();

const loading = ref(true);
const success = ref(false);

onMounted(async () => {
  const token = route.query.token as string;
  if (!token) {
    loading.value = false;
    return;
  }
  try {
    await invitationService.confirmEmail(token);
    success.value = true;
  } catch {
    success.value = false;
  } finally {
    loading.value = false;
  }
});
</script>
